import "./App.css";
import Navigation from "./navigation/MainNavigator";
import CarActivityWrapper from "./components/Layout/CarActivityWrapper";
import SessionWrapper from "./components/Layout/SessionWrapper";
import MQTTWrapper from "./components/Layout/MQTTWrapper";
import { Amplify } from "aws-amplify";
import ENV_CONFIG from "./config/ENV_CONFIG";

Amplify.configure({
	Auth: {
		userPoolWebClientId: ENV_CONFIG.PINPOINT_WEB_CLIENT_ID,
		userPoolId: ENV_CONFIG.PINPOINT_USER_POOL_ID,
		identityPoolId: ENV_CONFIG.PINPOINT_IDENTITY_POOL_ID,
		region: ENV_CONFIG.PINPOINT_REGION,
	},
	Analytics: {
		AWSPinpoint: {
			appId: ENV_CONFIG.PINPOINT_WEB_CLIENT_ID,
			region: ENV_CONFIG.PINPOINT_REGION,
		},
	},
});

function App() {
	return (
		<SessionWrapper>
			<MQTTWrapper>
				<CarActivityWrapper>
					<Navigation />
				</CarActivityWrapper>
			</MQTTWrapper>
		</SessionWrapper>
	);
}

export default App;
